var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hashtag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.49643 10.5795H2.73125C2.32739 10.5795 2 10.2521 2 9.84821C2 9.44436 2.32739 9.11696 2.73125 9.11696H4.71071L5.06161 6.88571H3.13304C2.72918 6.88571 2.40179 6.55832 2.40179 6.15446C2.40179 5.75061 2.72918 5.42321 3.13304 5.42321H5.27321L5.73745 2.70171C5.80658 2.29641 6.15784 2 6.56899 2C7.0916 2 7.48846 2.47035 7.40051 2.9855L6.98482 5.42054H9.81339L10.279 2.69286C10.3474 2.29266 10.6942 2 11.1002 2C11.6163 2 12.0082 2.46449 11.9214 2.97322L11.5036 5.42054H13.2688C13.6726 5.42054 14 5.74793 14 6.15179C14 6.55564 13.6726 6.88304 13.2688 6.88304H11.2705L10.9411 9.11429H12.867C13.2708 9.11429 13.5982 9.44168 13.5982 9.84554C13.5982 10.2494 13.2708 10.5768 12.867 10.5768H10.7455L10.2644 13.3099C10.1941 13.709 9.84737 14 9.44214 14C8.92491 14 8.53215 13.5345 8.61918 13.0246L9.03661 10.5795H6.18661L5.72096 13.3071C5.65264 13.7073 5.30578 14 4.8998 14C4.3837 14 3.99179 13.5355 4.07864 13.0268L4.49643 10.5795ZM6.75179 6.88304L6.41964 9.11696H9.24821L9.57768 6.88571H6.75179V6.88304Z",
    fill: "#714FFF",
    stroke: "white",
    strokeWidth: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.09131f7303e2e3589b877731be2f6cdb.svg";
export { ForwardRef as ReactComponent };